import React, { useState } from "react";
import axios from "axios";
import "./BankNiftyBid.css";

const BidForm = () => {
  const [bidType, setBidType] = useState("REGULAR");
  const [bidName, setBidName] = useState("");
  const [bidSlots, setBidSlots] = useState("");
  const [minimumBidSlots, setMinimumBidSlots] = useState("");
  const [individualBidCount, setIndividualBidCount] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [prizeRows, setPrizeRows] = useState([
    { id: 1, userCount: "", giftName: "", value: "", img: "" },
  ]);

  // Add row
  const handleAddRow = () => {
    setPrizeRows([
      ...prizeRows,
      { id: prizeRows.length + 1, userCount: "", giftName: "", value: "", img: "" },
    ]);
  };

  // Remove row
  const handleRemoveRow = (id) => {
    setPrizeRows(prizeRows.filter((row) => row.id !== id));
  };

  // Handle row input change
  const handlePrizeChange = (id, field, value) => {
    setPrizeRows(
      prizeRows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  // Build payload function
// Build payload function
const buildBidPayload = () => ({
  active: true,
  bidName,
  bidSlots: Number(bidSlots) || 0,
  bidType: bidType.toUpperCase(),
  frequency: "WEEKLY",
  imageUrl,
  minimumBidSlots,
  individualBidCount: Number(individualBidCount) || 0,
  prizeMasterList: prizeRows.map((row, idx) => ({
    level: idx + 1,
    eligibleUserCount: Number(row.userCount) || 0,
    prizeType: "GIFTS",
    giftName: row.giftName || "",
    prizeValue: Number(row.value) || 0,  // ✅ Add this line
    img: row.img || "",
  })),
});



  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = buildBidPayload();
    console.log("🚀 Final Payload:", payload);

    try {
      const res = await axios.post("https://prod-erp.nifty10.in/create-banknifty-bid", payload);
      alert("Bid Created Successfully!");
      console.log(res.data);
    } catch (err) {
      console.error("Error creating bid:", err);
      alert("Error creating bid. Check console for details.");
    }
  };

  return (
    <form className="uni-bid-form-container" onSubmit={handleSubmit}>
      <h2 className="nifty-bid-header">Bid Creation</h2>

      {/* Bid Type Dropdown */}
      <div className="nifty-bid-form-group">
        <label>Bid Type</label>
        <select
          className="nifty-bid-form-select"
          value={bidType}
          onChange={(e) => setBidType(e.target.value)}
        >
          <option value="REGULAR">Regular</option>
          <option value="SPECIAL">Special</option>
        </select>
      </div>

      {/* Common Fields */}
      <div className="nifty-bid-form-row">
        <div className="nifty-bid-form-group">
        <label htmlFor="bidName">
  Bid Name <span className="required-star">*</span>
</label>

        <input
          type="text"
          className="nifty-bid-form-input"
          placeholder="Bid Name"
          value={bidName}
          onChange={(e) => setBidName(e.target.value)}
          required
        />
        </div>
        <div className="nifty-bid-form-group">
          <label htmlFor="bidName">Bid Slots <span className="required-star">*</span></label>
        <input
          type="number"
          className="nifty-bid-form-input"
          placeholder="Bid Slots (-1 FOR INFINITY)"
          value={bidSlots}
          onChange={(e) => setBidSlots(e.target.value)}
          required
        />
      </div></div>

      <div className="nifty-bid-form-row">
        <div className="nifty-bid-form-group">
        <label htmlFor="bidName">Individual Bid Count <span className="required-star">*</span></label>
        <input
          type="number"
          className="nifty-bid-form-input"
          placeholder="Individual Bid Count"
          value={individualBidCount}
          onChange={(e) => setIndividualBidCount(e.target.value)}
          required
        /></div>
        <div className="nifty-bid-form-group">
          <label htmlFor="bidName">Image Url <span className="required-star">*</span></label>
        <input
          type="text"
          className="nifty-bid-form-input"
          placeholder="Image URL"
          value={imageUrl}
          onChange={(e) => setImageUrl(e.target.value)}
          required
        /></div>
      </div>
 <div className="nifty-bid-form-row">
  <div className="nifty-bid-form-group">
          <label htmlFor="bidName">Minimum Bid Slots <span className="required-star">*</span></label>
        <input
          type="number"
          className="nifty-bid-form-input"
          placeholder="Minimum Bid Slots"
          value={minimumBidSlots}
          onChange={(e) => setMinimumBidSlots(e.target.value)}
          
        /></div></div>
      {/* Prize Breakdown */}  
      <h3 className="nifty-bid-prize-breakdown-header">Prize Breakdown</h3>
      <table className="nifty-bid-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>No. of Users</th>
            <th>Name</th>
            <th>Value</th>
            <th>Image URL</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {prizeRows.map((row, idx) => (
            <tr key={row.id}>
              <td>Rank {idx + 1}</td>
              <td>
                <input
                  type="number"
                  className="nifty-bid-table-input"
                  placeholder="Users"
                  value={row.userCount}
                  onChange={(e) =>
                    handlePrizeChange(row.id, "userCount", e.target.value)
                  
                  }
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  className="nifty-bid-table-input"
                  placeholder="Name"
                  value={row.giftName}
                  onChange={(e) =>
                    handlePrizeChange(row.id, "giftName", e.target.value)
                  }
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  className="nifty-bid-table-input"
                  placeholder="Value"
                  value={row.value}
                  onChange={(e) =>
                    handlePrizeChange(row.id, "value", e.target.value)
                  }
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  className="nifty-bid-table-input"
                  placeholder="Image URL"
                  value={row.img}
                  onChange={(e) =>
                    handlePrizeChange(row.id, "img", e.target.value)
                  }
                  required
                />
              </td>
              <td>
                <button
                  type="button"
                  className="nifty-bid-table-action-btn"
                  onClick={() => handleRemoveRow(row.id)}
                >
                  ❌
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button type="button" className="nifty-bid-add-btn" onClick={handleAddRow}>
        Add Row
      </button>

      <div
        className="uni-form-group uni-submit-container"
        style={{ gridColumn: "1 / span 2", textAlign: "right" }}
      >
        <button type="submit" className="uni-submit-button" style={{ background: "#1c2e4a" }}>
          Create Bid
        </button>
      </div>
    </form>
  );
};

export default BidForm;